// src/utils/analytics.js
import { getAnalytics, logEvent as firebaseLogEvent } from "firebase/analytics";
import { initializeApp } from "firebase/app";

// Konfigurasi ulang jika perlu, atau pass `app` instance dari firebase.js
// Untuk sederhananya, kita akan mengandalkan inisialisasi di firebase.js 
// Tapi getAnalytics butuh 'app' instance.
// Best practice: Export 'app' dari firebase.js dan import di sini, 
// atau biarkan getAnalytics() mengambil default app jika sudah di-init.

// Opsi A: Import app dari firebase.js (Recommended)
import { app } from "../firebase";

let analytics = null;

// Initialize Analytics
try {
    // Hanya init di browser environment
    if (typeof window !== 'undefined') {
        analytics = getAnalytics(app);
        console.log("Firebase Analytics Initialized 🚀");
    }
} catch (error) {
    console.warn("Analytics init failed (might be offline):", error);
}

/**
 * Log a generic event
 * @param {string} eventName 
 * @param {object} eventParams 
 */
export const logEvent = (eventName, eventParams = {}) => {
    if (analytics) {
        try {
            firebaseLogEvent(analytics, eventName, eventParams);
            // Debug log di development
            if (process.env.NODE_ENV === 'development') {
                console.log(`[Analytics] ${eventName}:`, eventParams);
            }
        } catch (error) {
            console.warn("Failed to log event:", error);
        }
    }
};

/**
 * Log Screen View manually
 * @param {string} screenName 
 */
export const logScreenView = (screenName) => {
    logEvent('screen_view', {
        firebase_screen: screenName,
        firebase_screen_class: screenName
    });
};

/**
 * Log View Item (Product Detail)
 * @param {object} item - product object
 */
export const logViewItem = (item) => {
    if (!item) return;
    logEvent('view_item', {
        currency: 'IDR',
        value: item.price,
        items: [{
            item_id: item.id,
            item_name: item.name,
            item_category: item.category || 'general',
            price: item.price,
            quantity: 1
        }]
    });
};

/**
 * Log Add to Cart
 * @param {object} item 
 */
export const logAddToCart = (item) => {
    if (!item) return;
    logEvent('add_to_cart', {
        currency: 'IDR',
        value: item.price,
        items: [{
            item_id: item.id,
            item_name: item.name,
            item_category: item.category || 'general',
            price: item.price,
            quantity: 1 // Default 1 for single add
        }]
    });
};

/**
 * Log Begin Checkout
 * @param {Array} cartItems 
 * @param {number} totalValue 
 */
export const logBeginCheckout = (cartItems, totalValue) => {
    logEvent('begin_checkout', {
        currency: 'IDR',
        value: totalValue,
        items: cartItems.map(item => ({
            item_id: item.id,
            item_name: item.name,
            price: item.price,
            quantity: item.quantity
        }))
    });
};

/**
 * Log Purchase
 * @param {string} transactionId 
 * @param {number} value 
 * @param {Array} items 
 */
export const logPurchase = (transactionId, value, items) => {
    logEvent('purchase', {
        transaction_id: transactionId,
        currency: 'IDR',
        value: value,
        items: items.map(item => ({
            item_id: item.id,
            item_name: item.name,
            price: item.price,
            quantity: item.quantity
        }))
    });
};
